import { db } from '../config';
import { 
  collection,
  getDocs,
  doc,
  updateDoc,
  serverTimestamp
} from 'firebase/firestore';
import { migrateSiteMedia } from '../siteMedia';

export const migrateMediaToNewCollection = async () => {
  try {
    console.log('Starting media migration...');
    const sitesRef = collection(db, 'sites');
    const sitesSnap = await getDocs(sitesRef);
    
    const migrationPromises = sitesSnap.docs.map(async (siteDoc) => {
      const siteId = siteDoc.id;
      const siteData = siteDoc.data();
      
      // Skip if no media array
      if (!siteData.media || !Array.isArray(siteData.media) || siteData.media.length === 0) {
        console.log(`No media to migrate for site ${siteId}`);
        return;
      }

      // Migrate media for this site
      console.log(`Migrating media for site ${siteId}`);
      const result = await migrateSiteMedia(siteId);
      
      if (result.success) {
        console.log(`Successfully migrated media for site ${siteId}`);
      } else {
        console.error(`Failed to migrate media for site ${siteId}:`, result.error);
      }
    });

    await Promise.all(migrationPromises);
    console.log('Media migration completed');
    
    return { success: true };
  } catch (error) {
    console.error('Error during media migration:', error);
    return { success: false, error: error.message };
  }
};

// Function to run migration
export const runMediaMigration = async () => {
  console.log('Running media migration...');
  const result = await migrateMediaToNewCollection();
  if (result.success) {
    console.log('Media migration completed successfully');
  } else {
    console.error('Media migration failed:', result.error);
  }
  return result;
};
